'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  ', '\n'], ['\n  display: flex;\n  ', '\n']);

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _reactCreateComponentFromTagProp = require('react-create-component-from-tag-prop');

var _reactCreateComponentFromTagProp2 = _interopRequireDefault(_reactCreateComponentFromTagProp);

require('../types');

var _grid = require('../mixins/grid');

var _grid2 = _interopRequireDefault(_grid);

var _GridUnit = require('./GridUnit');

var _GridUnit2 = _interopRequireDefault(_GridUnit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var GridComponent = (0, _reactCreateComponentFromTagProp2.default)({
  tag: 'div',
  prop: 'component',
  propsToOmit: ['halign', 'valign', 'reverse', 'wrap']
});

var Grid = (0, _styledComponents2.default)(GridComponent)(_templateObject, _grid2.default);

exports.default = Grid;


//////////////////
// WEBPACK FOOTER
// ./~/styled-components-grid/dist/cjs/components/Grid.js
// module id = 1315
// module chunks = 0